var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotwear1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    rx: 52,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4824_41633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.3973 18.7516L49.7108 35.1952C49.9212 35.3682 51.824 33.9386 52.3195 34.2874L55.0679 41.6401L53.6245 54.6349L58.9096 81.2156L56.2152 84.6283C55.8526 84.8498 55.1662 84.6145 54.7053 84.7446C54.1462 84.9037 53.2923 86.1423 52.6793 86.3001C52.2378 86.4122 51.759 86.2835 51.2968 86.3804C50.6034 86.527 49.6084 87.0183 48.9829 86.999C48.3573 86.9796 47.6086 86.5091 46.9873 86.3776C46.4877 86.2724 45.9687 86.4219 45.4719 86.2669C44.928 86.0966 44.1433 84.9051 43.5759 84.7446C43.093 84.6076 42.5422 84.8415 42.0689 84.6256C41.8295 84.5162 39.8311 82.4141 39.7882 82.1788L42.2349 55.6286L39.4561 41.7978L43.0542 30.876L41.0033 26.0711L51.02 18.0196C51.9679 17.675 54.2874 18.742 55.3973 18.7516Z",
    fill: "#AE2100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3742 63.8639L57.1826 64.7703L54.603 54.964L56.29 41.8501L52.1978 30.4163L55.973 19.8861L63.3742 63.8639Z",
    fill: "#AE2100"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4824_41633"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.918,
    height: 69.05,
    fill: "white",
    transform: "translate(39.4561 17.95)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotwear1);
export default __webpack_public_path__ + "static/media/notwear1.860808418931632e3689e10525068f30.svg";
export { ForwardRef as ReactComponent };